export default "__VITE_PUBLIC_ASSET__aecaf332__"